import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

/**
 * Função para retornar usuários responsáveis (Para) da revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postResponsaveisPara = async ({
  authToken,
  idAutonomoResponsavel,
}: {
  authToken: string;
  idAutonomoResponsavel: string;
}): Promise<any> => {
  const url = "/api/autonomo/ListarEquipeAutonomoParaRevenda";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(
    url,
    { idAutonomoResponsavel },
    config
  );
  return response?.data;
};
